"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Source: https://www.sitepoint.com/using-fourier-transforms-web-audio-api/#synthesizing-a-horn

var real = exports.real = [0, 0.4, 0.4, 1, 1, 1, 0.3, 0.7, 0.6, 0.5, 0.9, 0.8];

var imag = exports.imag = real.map(function () {
  return 0;
});